import Paper from "@mui/material/Paper";
import { ReactComponent as MyTemplateIcon } from "assets/icons/MyTemplateIcon.svg";
import { ReactComponent as NewTemplateIcon } from "assets/icons/NewTemplateIcon.svg";
import { ReactComponent as TextMessegeIcon } from "assets/icons/TextMessegeIcon.svg";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCardContent } from "services/api/communication";
import {
  Button,
  CampaignIcon,
  CardsRow,
  CardsScroll,
  Desc,
  Title,
  TitleCampaignCards,
} from "./Theme";
export const NewAutomation = ({ handleResetFormik }) => {
  const dispatch = useDispatch();
  const twilioAccount = JSON.parse(
    localStorage.getItem("organization")
  )?.twilio;
  const CampaignCardsData = [
    {
      icon: <NewTemplateIcon />,
      title: "New template",
      desc: "Create a new template",
    },
    {
      icon: <MyTemplateIcon />,
      title: "My template",
      desc: "Use a template from your saved collection",
    },
    {
      icon: <TextMessegeIcon />,
      title: "Text message",
      desc: "Send a text message",
    },
  ];
  useEffect(() => {
    handleResetFormik();
  }, []);
  return (
    <>
      <TitleCampaignCards>
        <h1>Create an Automation</h1>
      </TitleCampaignCards>
      <CardsScroll>
        <CardsRow>
          {CampaignCardsData.map((item) => (
            <Paper
              key={item.title}
              sx={{
                height: 292,
                width: 208,
                borderRadius: 5,
                backgroundColor: "#F3F6F9 !important",
                boxShadow: "0 0 50px 0 rgba(82, 63, 105, 0) !important",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "5rem",
                position: "relative",
                paddingTop: "30px",
                flex: "0 0 208px",
              }}
            >
              <CampaignIcon>{item?.icon}</CampaignIcon>
              <Title>{item?.title}</Title>
              <Desc>{item?.desc}</Desc>
              <Button
                onClick={() => {
                  dispatch(setCardContent(item?.title));
                }}
                disabled={item?.title === "Text message" && !twilioAccount}
              >
                Create
              </Button>
            </Paper>
          ))}
        </CardsRow>
      </CardsScroll>
    </>
  );
};
